module.exports = __webpack_public_path__ + "static/hero-395e16938350061a3df795d83bf5bef5.mp4";